import { Observable } from 'rxjs';
import {
  IFormModelField,
  IFormActions,
  IComboList
} from './../interfaces/forms.interface';
import { FormType } from './../enums/form.enum';
import { isArray } from 'util';
import { getObjectProperty } from '../functions/string.helpers';
import * as moment from 'moment';
export * from './messages';

export const isConstructor = f => {
  try {
    Reflect.construct(String, [], f);
  } catch (e) {
    return false;
  }
  return true;
};

export const isValidObject = obj => {
  return (
    typeof obj === 'object' &&
    obj &&
    !isArray(obj) &&
    !moment.isMoment(obj) &&
    isConstructor(obj.constructor)
  );
};

export class FormModelField implements IFormModelField {
  private disableWhen: (() => boolean)[] = [];

  constructor(
    public value: any,
    public loading: boolean,
    public disabled: boolean,
    public valid: boolean,
    public errors: any[],
    public rules: any[],
    public fieldName: string,
    public fieldLabel: string,
    public parentPrefix: string
  ) {}

  setValue = (value: any) => {
    this.value = value;
  };

  setValidator = (validator: any[]) => {
    this.rules = validator;
  };
  setErrors = (errors: any[]) => {
    this.errors = errors;
    this.valid = false;
  };
  clearErrors = () => {
    this.errors = [];
    this.valid = true;
  };
  setFieldLabel = label => {
    this.fieldLabel = label;
  };
  
  addDisableWhen = (disableWhen: () => boolean) => {
    this.disableWhen.push(disableWhen);
  };

  get isDisabled(): boolean {
    let neededDisabled = false;
    if (this.disableWhen.length > 0) {
      neededDisabled = this.disableWhen
        ? !this.disableWhen.map(f => f()).every(b => !b)
        : false;
    }
    return this.disabled || neededDisabled;
  }

  validate = () => {
    if (this.rules) {
      this.valid = true;
      this.errors = [];
      this.rules.forEach(rule => {
        if (rule) {
          const ret = rule({}, this.fieldName, this.value, this.fieldLabel);
          if (!ret.valid) {
            this.errors.push(ret.msg);
          }
        }
      });
      this.valid = this.errors.length === 0;
    }
  };
}

export interface ISubmitOptions {
  submitParams: any;
}

export interface IFormModelOptions {
  confirmOnSave?: () => Promise<any>;
  onSave?: (formValue, options: ISubmitOptions) => Observable<any>;
  onUpdate?: (formValue, options: ISubmitOptions) => Observable<any>;
  onSearch?: (formValue, options: ISubmitOptions) => Observable<any> | void;
  onGet?: () => Observable<any>;
  validateOnSave?: () => boolean;
  disableFields?: { fields: string[] | string; when: () => boolean }[];
  disableOnGet?: boolean;
  disableOnSave?: boolean;
  disableOnUpdate?: boolean;
}

export class FormModel<T> {
  public loading;
  public model: { [prop: string]: IFormModelField } = {};
  private options: IFormModelOptions = {
    confirmOnSave: null,
    onSave: null,
    onUpdate: null,
    onGet: null,
    onSearch: null,
    disableOnGet: true,
    disableOnSave: true,
    disableOnUpdate: true
  };

  private defaultModel: T = null;

  constructor(
    private formType: FormType,
    defaultModel: T,
    validators = null,
    options: IFormModelOptions = null
  ) {
    this.defaultModel = JSON.parse(JSON.stringify(defaultModel));

    this.setModel(defaultModel);

    if (options) {
      this.setOptions(options);
    }

    if (validators) {
      this.setValidators(validators);
    }

    if (this.options.disableFields) {
      this.setDisableFieldsToModel();
    }

    if (
      this.options.onGet &&
      (formType === FormType.CONSULTAR || formType === FormType.EDITAR)
    ) {
      setTimeout(() => {
        this.GetData();
      });
    }
  }

  private buildModel = (model, parentPrefix) => {
    const newModel: { [prop: string]: IFormModelField | any } = {};
    Object.keys(model).forEach(x => {
      if (isValidObject(model[x])) {
        newModel[x] = this.buildModel(
          model[x],
          `${parentPrefix}${parentPrefix ? '.' : ''}${x}`
        );
      } else {
        newModel[x] = new FormModelField(
          model[x],
          false,
          false,
          true,
          [],
          null,
          x,
          null,
          parentPrefix
        );
      }
    });

    return newModel;
  };

  private setModel = (model: T) => {
    this.model = this.buildModel(model, '');
    // Object.keys(model).forEach(x => {
    //   if (
    //     typeof model[x] === 'object' &&
    //     model[x] &&
    //     model[x].constructor === Object
    //   ) {
    //     console.log(model[x]);
    //   } else {
    //     this.model[x] = new FormModelField(
    //       model[x],
    //       false,
    //       false,
    //       true,
    //       [],
    //       null,
    //       x,
    //       null,
    //     );
    //   }

    // this.model[ x ] = {
    //   value: model[ x ],
    //   loading: false,
    //   disabled: false,
    //   valid: true,
    //   errors: [],
    //   rules: null,
    //   fieldName: x,
    //   setValue: (value) => { this.model[ x ].value = value; },
    //   setValidator: (validator: any[]) => { this.model[ x ].rules = validator; },
    //   setErrors: (errors: any[]) => { this.model[ x ].valid = false; this.model[ x ].errors = errors; },
    //   clearErrors: () => { this.model[ x ].valid = true; this.model[ x ].errors = []; }
    // }
  };

  private setValidators = validators => {
    Object.keys(validators).forEach(k => {
      if (validators[k]) {
        const field = getObjectProperty(this.model, k);
        if (field !== undefined) {
          field.setValidator(validators[k]);
        }
      }
    });
  };

  get value(): T {
    // Object.keys(this.model).forEach(x => {
    //   ret[x] = this.model[x].value;
    // });
    return this.buildValue(this.model) as any;
  }

  private buildValue = (model: any) => {
    const obj = {};
    Object.keys(model).forEach(x => {
      if (model[x] !== undefined) {
        if (model[x] instanceof FormModelField) {
          obj[x] = model[x].value;
        } else {
          obj[x] = this.buildValue(model[x]);
        }
      }
    });

    return obj;
  };

  /**
   * Realiza la validación de los campos indicados en la propiedad "validators"
   *
   */
  validate = () => {
    const { value: formValue } = this;

    const validateModel = model => {
      Object.keys(model).forEach(k => {
        if (model[k] !== undefined) {
          if (model[k] instanceof FormModelField) {
            if (model[k].rules) {
              model[k].valid = true;
              model[k].errors = [];
              model[k].rules.forEach(rule => {
                if (rule) {
                  const ret = rule(
                    formValue,
                    model[k].fieldName,
                    model[k].value,
                    model[k].fieldLabel
                  );
                  if (!ret.valid) {
                    model[k].errors.push(ret.msg);
                  }
                }
              });
              model[k].valid = model[k].errors.length === 0;
            }
          } else {
            validateModel(model[k]);
          }
        }
      });
    };
    validateModel(this.model);
    // Object.keys(this.model)
    //   .filter(k => this.model[k].rules)
    //   .forEach(k => {
    //     this.model[k].valid = true;
    //     this.model[k].errors = [];
    //     // const rules = this.model[ k ].rules.split("|");

    //     // rules.forEach(rule => {
    //     //   const ret = ValidateRule(this.value, k, this.model[ k ].value, rule);
    //     //   if (!ret.valid) {
    //     //     this.model[ k ].errors.push(ret.msg);
    //     //   }
    //     // });
    //     this.model[k].rules.forEach(rule => {
    //       if (rule) {
    //         const ret = rule(
    //           formValue,
    //           this.model[k].fieldName,
    //           this.model[k].value,
    //           this.model[k].fieldLabel,
    //         );
    //         if (!ret.valid) {
    //           this.model[k].errors.push(ret.msg);
    //         }
    //       }
    //     });

    //     this.model[k].valid = this.model[k].errors.length === 0;
    //   });
  };

  get valid() {
    const isModelValid = model => {
      return (
        Object.keys(model).filter(k => {
          if (model[k] instanceof FormModelField) {
            return !model[k].valid;
          } else {
            return !isModelValid(model[k]);
          }
        }).length === 0
      );
    };
    return isModelValid(this.model);
  }

  public submit(params: any = null) {
    this.validate();

    const customValid = this.options.validateOnSave
      ? this.options.validateOnSave()
      : true;

    if (!this.valid || !customValid) {
      return false;
    }

    const _submit = () => {
      if (this.formType === FormType.REGISTRAR) {
        this.loading = true;
        if (this.options.disableOnSave) {
          this.disable();
        }
        const obs = this.options.onSave(this.value, { submitParams: params });
        if (obs) {
          obs.subscribe(
            () => {
              if (this.options.disableOnSave) {
                this.enable();
              }
              this.loading = false;
            },
            error => {
              if (this.options.disableOnSave) {
                this.enable();
              }
              this.loading = false;
            }
          );
        }
      }

      if (this.formType === FormType.EDITAR) {
        this.loading = true;
        if (this.options.disableOnUpdate) {
          this.disable();
        }
        const obs = this.options.onUpdate(this.value, { submitParams: params });
        if (obs) {
          obs.subscribe(
            () => {
              if (this.options.disableOnUpdate) {
                this.enable();
              }
              this.loading = false;
            },
            error => {
              if (this.options.disableOnUpdate) {
                this.enable();
              }
              this.loading = false;
            }
          );
        }
      }

      if (this.formType === FormType.BUSCAR) {
        this.loading = true;
        this.disable();
        const obs = this.options.onSearch(this.value, { submitParams: params });
        if (obs) {
          obs.subscribe(
            () => {
              this.enable();
              this.loading = false;
            },
            error => {
              this.enable();
              this.loading = false;
            }
          );
        } else {
          this.loading = false;
          this.enable();
        }
      }
    };

    if (this.options.confirmOnSave) {
      this.options.confirmOnSave().then(c => {
        if (c) {
          _submit();
        }
      });
    } else {
      _submit();
    }
  }

  /*private setValuesToModel = (model: T) => {
    Object.keys(model).forEach(x => {
      if (this.model[x] !== undefined) {
        this.model[x].value = model[x];
      }
    });
  };*/

  public GetData = () => {
    if (this.options.onGet) {
      if (this.options.disableOnGet) {
        this.disable();
      }
      this.loading = true;
      this.options.onGet().subscribe(
        value => {
          if (value) {
            this.patchValue(value);
          }
          if (this.formType === FormType.EDITAR) {
            if (this.options.disableOnGet) {
              this.enable();
            }
          }
          this.loading = false;
        },
        error => {
          if (this.options.disableOnGet) {
            this.enable();
          }
          this.loading = false;
        }
      );
    }
  };

  private getObjectKeys = (model, parentProp = '') => {
    let keys = [];

    Object.keys(model).forEach(k => {
      if (model[k] !== undefined) {
        if (model[k] instanceof FormModelField) {
          keys.push(`${parentProp}${k}`);
        } else {
          keys = [
            ...keys,
            ...this.getObjectKeys(model[k], `${parentProp}${k}.`)
          ];
        }
      }
    });
    return keys;
  };

  public disable = (fields: string[] = null) => {
    if (!fields) {
      fields = this.getObjectKeys(this.model);
    }

    fields.forEach(k => {
      this.get(k).disabled = true;
    });
  };

  public enable = (fields: string[] = null) => {
    if (!fields) {
      fields = this.getObjectKeys(this.model);
    }

    fields.forEach(k => {
      this.get(k).disabled = false;
    });
  };

  public setOptions = (options: IFormModelOptions) => {
    this.options = { ...this.options, ...options };
  };

  private setValuesFromObject = (obj, model) => {
    Object.keys(obj).forEach(k => {
      if (model[k] !== undefined) {
        if (isValidObject(obj[k])) {
          if (!(model[k] instanceof FormModelField)) {
            this.setValuesFromObject(obj[k], model[k]);
          }
        } else {
          model[k].setValue(obj[k]);
        }
      }
    });
  };

  public patchValue = value => {
    this.setValuesFromObject(value, this.model);
  };

  public setValue = value => {
    this.reset();
    this.patchValue(value);
  };

  /**
   * Obtiene el control con sus metodos, segun el campo indicado
   */
  public get = (fieldName: string): IFormModelField => {
    return getObjectProperty(this.model, fieldName);
  };

  /**
   * Obtiene el valor del control indicado
   */
  public getValue = (fieldName = null) => {
    if (fieldName) {
      const field = this.get(fieldName);
      if (field instanceof FormModelField) {
        return field.value;
      } else if (field !== undefined) {
        return this.buildValue(field);
      }
      return field;
    }
    return this.value;
  };

  public reset = () => {
    this.setValuesFromObject(this.defaultModel, this.model);
  };

  private setDisableFieldsToModel = () => {
    let fields = [];
    this.options.disableFields.forEach(x => {
      if (typeof x.fields === 'string') {
        if (x.fields === '*') {
          fields = this.getObjectKeys(this.model);
        }
      } else {
        fields = [...(x.fields as string[])];
      }
      fields.forEach(f => {
        const field = this.get(f);
        if (field !== undefined && field instanceof FormModelField) {
          field.addDisableWhen(x.when);
        }
      });
    });
  };

  // public getSelectedValue = fieldName => {
  //   return null;
  //   // if (this.model[fieldName] === undefined) {
  //   //   return null;
  //   // }
  //   // return this.model[fieldName].selectedValue;
  // };

  public clearErrors = (fields: string[] = null) => {
    if (!fields) {
      const clearModelErrors = (model: { [prop: string]: IFormModelField }) => {
        Object.keys(model).forEach(k => {
          if (model[k] !== undefined) {
            if (model[k] instanceof FormModelField) {
              if (!model[k].valid) {
                model[k].clearErrors();
              }
            } else {
              clearModelErrors(model[k] as any);
            }
          }
        });
      };
      clearModelErrors(this.model);
    } else {
      fields.forEach(f => {
        const formField = this.get(f);
        if (formField) {
          formField.clearErrors();
        }
      });
    }
  };
}

export class ComboList implements IComboList {
  list: any[];
  loading: boolean;
  constructor(value, loading = false) {
    this.list = value;
    this.loading = loading;
  }
}
